import React from 'react';
import { createPortal } from 'react-dom';
import { hasValue } from '@famly/stat_ts-utils_has-value';
import { PortalRootId } from './constants';
const Portal = (props) => {
    const { dynamicId, rootId, children } = props;
    const id = dynamicId || rootId || PortalRootId.portalRoot;
    const [element, setElement] = React.useState(null);
    /**
     * To ensure that we can reliably select the targetted DOM element we need to defer the query
     * until after current layout operations. Otherwise it is not possible to target elements rendered
     * in the same component.
     */
    React.useLayoutEffect(() => {
        setElement(() => {
            const element = document.getElementById(id);
            return element;
        });
    }, [id]);
    return hasValue(element) ? createPortal(children, element) : null;
};
export default Portal;
